export const TIMELINE_ITEM_TYPE_COLOR_VARS: Record<string, string> = {
  historical_event: 'var(--timeline-type-historical-event)',
  auto_historical: 'var(--timeline-type-auto-historical)',
  fictional_event: 'var(--timeline-type-fictional-event)',
  auto_fictional: 'var(--timeline-type-auto-fictional)',
  planning: 'var(--timeline-type-planning)',
  other: 'var(--timeline-type-other)',
};

export function timelineItemTypeClassName(itemType: string): string {
  return `timeline-type-${itemType}`;
}

export function timelineItemTypeSwatchColor(itemType: string): string | undefined {
  return TIMELINE_ITEM_TYPE_COLOR_VARS[itemType];
}
